import { Descriptions, Flex, Space, type DescriptionsProps, Typography, Card } from "antd"
import type { BillConcept,  } from "../types/billJson";
import type { BillJson } from "../types";

const { Title } = Typography;
const BillDetails = ({ billJson }: { billJson: BillJson | null }) => {

   if (!billJson) {
      return <></>
   }

   const itemsDetailsSender = (senderData: BillJson) => {
      const itemsBill: DescriptionsProps['items'] = [
         {
            label: 'Emisor Nombre',
            children: senderData.sender_name,
            span: 3
         },
         {
            label: 'Emisor RFC',
            children: senderData.sender_rfc,
            span: 1
         },
         {
            label: 'Emisor regimen fiscal',
            children: senderData.sender_tax_regime,
            span: 2
         },
         {
            label: 'Receptor Nombre',
            children: senderData.receptor_name,
            span: 3
         },
         {
            label: 'Receptor RFC',
            children: senderData.receptor_rfc,
         },
         {
            label: 'Receptor regimen fiscal',
            children: senderData.receptor_tax_regime,
            span: 3
         },
         {
            label: 'Receptor Uso CDFI',
            children: senderData.receptor_CFDI_usage,
         },
         {
            label: 'Receptor dirección',
            children: senderData.receptor_address,
            span: 3
         },
         {
            label: 'Fecha',
            children: senderData.date,
         },
         {
            label: 'No certificado',
            children: senderData.NoCertificate,
            span: 3
         },
         {
            label: 'Tipo de comprobante',
            children: senderData.typeBill,
         },
         {
            label: 'Metodo pago',
            children: senderData.paymentMethod,
            span: 3
         },
         {
            label: 'Sub total',
            children: senderData.subTotal,
         },
         {
            label: 'Total',
            children: senderData.total,
         }

      ].map((item, index) => ({
         ...item,
         key: index.toString(),
      }));
      return itemsBill;
   }

   const conceptBill = (concept: BillConcept) => {
      const itemsConcept: DescriptionsProps['items'] = [
         {
            label: 'Clave producto/servicio',
            children: concept.ClaveProdServ,
         },
         {
            label: 'Descripcion',
            children: concept.Descripcion,
            span: 2
         },
         {
            label: 'Clave Unidad',
            children: concept.ClaveUnidad,
         },
         {
            label: 'Unidad',
            children: concept.Unidad,
            span: 2
         },
         {
            label: 'Cantidad',
            children: concept.Cantidad,
         },
         {
            label: 'Valor unitario',
            children: concept.ValorUnitario,
         },
         {
            label: 'Importe',
            children: concept.Importe,
         },
      ].map((item, index) => ({
         ...item,
         key: index.toString(),
      }));
      return itemsConcept;
   }
   return (
      <>
         <Descriptions items={itemsDetailsSender(billJson)} title="Datos Emisor" bordered />
         <br />
         <Space direction="vertical" size="large" style={{ width: "100%" }}>

            <Flex justify="space-between" align="center">
               <Title level={4} style={{ margin: 0 }}>
                  Conceptos
               </Title>
               <Typography.Text type="secondary">
                  {billJson.concepts.length} concepto(s)
               </Typography.Text>
            </Flex>

            {billJson.concepts.map((concept, index) => (
               <Card
                  key={index}
                  size="small"
                  bordered
                  style={{ borderRadius: 12 }}
               >
                  <Descriptions
                     size="small"
                     column={2}
                     title={
                        <Typography.Text strong>
                           {concept.Descripcion}
                        </Typography.Text>
                     }
                     items={conceptBill(concept)}
                  />
               </Card>
            ))}
         </Space>
      </>
   )
}

export default BillDetails;